'use client';
import { abs } from '@s7/utils';
import { canBeVerticallyScrolled, canBeHorizontallyScrolled } from './canBeScrolled.js';

const canBeScrolled = (axis, node)=>axis === 'v' ? canBeVerticallyScrolled(node) : canBeHorizontallyScrolled(node);
const locationCouldBeScrolled = (axis, node)=>{
    const ownerDocument = node.ownerDocument;
    let current = node;
    do {
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        const isScrollable = canBeScrolled(axis, current);
        if (isScrollable) {
            const [, scrollHeight, clientHeight] = getScrollVariables(axis, current);
            if (scrollHeight > clientHeight) {
                return true;
            }
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body)
    return false;
};
const getVScrollVariables = (element)=>{
    const { scrollTop, scrollHeight, clientHeight } = element;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
const getHScrollVariables = (element)=>{
    const { scrollLeft, scrollWidth, clientWidth } = element;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
const getScrollVariables = (axis, node)=>axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
///
/**
 * Если направление элемента — rtl (справа налево), то scrollLeft равно 0,
 * когда полоса прокрутки находится в крайнем правом положении,
 * и становится всё более отрицательным по мере прокрутки к концу содержимого.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
 */ const getDirectionFactor = (axis, direction)=>axis === 'h' && direction === 'rtl' ? -1 : 1;
///
const handleScroll = (axis, endTarget, event, sourceDelta, noOverscroll)=>{
    const directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    const delta = directionFactor * sourceDelta;
    let target = event.target;
    const targetInLock = endTarget.contains(target);
    let shouldCancelScroll = false;
    const isDeltaPositive = delta > 0;
    let availableScroll = 0;
    let availableScrollTop = 0;
    do {
        const [position, scroll, capacity] = getScrollVariables(axis, target);
        const elementScroll = scroll - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (canBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) {
            target = target.host;
        } else {
            target = target.parentNode;
        }
    }while (/* Содержимое в портале */ !targetInLock && target !== document.body || /* Собственное содержимое */ targetInLock && (endTarget.contains(target) || endTarget === target))
    /* Обрабатываем ситуацию нестандартного zoom */ if (isDeltaPositive && (noOverscroll && abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) {
        shouldCancelScroll = true;
    } else if (!isDeltaPositive && (noOverscroll && abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

export { handleScroll, locationCouldBeScrolled };
//# sourceMappingURL=handleScroll.js.map
